/**
 * Form for entering an MFA code
 */

import Form from "Scripts/common/form"
import Pin from "Scripts/common/pin"

export default class MfaEnterCode {
	constructor(opts = {}) {
		this.formEl = opts.form ?? $("#form-mfa");

		const endpoint = this.formEl.attr('action');

		this.form = new Form({
			form: this.formEl,
			endpoint: endpoint + (endpoint.includes('ajax') ? '' : '/ajax'), // This is so that the form works should JS fail for whatever reason
			willRedirect: true,
			callback: opts.callback ?? this.onCorrectPinEntered.bind(this),
		});

		this.input = $("#code");

		this.lastEnteredPin = "";

		new Pin({
			group: $(".js-pin-group"),
			onCompletePinEntered: this.onEnteredPin.bind(this),
		});

		this.input.on("change keyup", this.onEnteredPin.bind(this));
	}

	onCorrectPinEntered(data) {
		console.log("MfaEnterCode.onCorrectPinEntered", data);

		if(data.success) {
			window.location = data.payload.redirectUrl || "/dashboard";
		}
	}

	onEnteredPin(pinValue) {
		// Only check when the PIN has changed
		if (this.lastEnteredPin != pinValue) {
			console.log("MfaEnterCode.onEnteredPin");
			this.formEl.submit();
		}

		this.lastEnteredPin = pinValue
	}
}